import React from 'react';
import { cn } from 'cn';

type ButtonToolbarProps = {
  /** Só para posicionar o toolbar: margem (`tw:mt-3`) ou `pull-right`. O espaço entre os botões já vem do toolbar. */
  className?: string;
  /** Os botões, sem margem própria (`ml-2`/`mr-2`). */
  children?: React.ReactNode;
};

// Substituto do ButtonToolbar do reactstrap. Fechado de propósito: o espaço
// entre os botões é do toolbar (gap), não dos filhos, e o className serve só
// para posicionar o toolbar (margem, float).
/**
 * Linha de botões com 8px entre eles. Substitui o `ButtonToolbar` do reactstrap.
 * @import import ButtonToolbar from 'src/componentes/button-toolbar';
 */
export default function ButtonToolbar({
  className,
  children,
}: ButtonToolbarProps) {
  return (
    <div className={cn('tw:flex tw:flex-wrap tw:gap-2', className)}>
      {children}
    </div>
  );
}
